export function normalizeTranscriptWords(providerWords, duration) {
  if (!Array.isArray(providerWords) || providerWords.length === 0) {
    throw new Error('No speech was detected in this video.');
  }

  const words = providerWords
    .map((word, index) => ({
      id: `source-${index}-${Math.round(Number(word.start) * 1000)}`,
      text: typeof word.word === 'string' ? word.word.trim() : '',
      start: word.start,
      end: word.end,
      ...(typeof word.speaker==='string'&&/^[A-Za-z0-9_-]{1,16}$/.test(word.speaker)?{speaker:word.speaker}:{}),
      ...(Number.isFinite(word.originalStart) && Number.isFinite(word.originalEnd) ? {originalStart:word.originalStart,originalEnd:word.originalEnd} : {})
    }))
    .filter(word => word.text)
    .sort((left, right) => left.start - right.start);

  if (!words.length) throw new Error('The transcription did not contain usable words.');

  let line = 0;
  let previous = null;
  return words.map((word, index) => {
    if (
      !Number.isFinite(word.start) ||
      !Number.isFinite(word.end) ||
      word.start < 0 ||
      word.start >= duration ||
      word.end <= word.start ||
      word.end > duration + 0.25
    ) {
      throw new Error('The transcription returned invalid source timestamps.');
    }
    if (previous && (word.start - previous.end > 1.25 || index % 12 === 0)) line += 1;
    previous = word;
    return {...word, end: Math.min(word.end, duration), line};
  });
}

